<template>
  <div>
    <general-availability
      v-if="showGeneralAvailability"
      :schedule="schedule"
      :sitter-name="sitterName"
      :availability-valid-until="availabilityValidUntil"
      :care-type="careType"
      :edit-mode-active="editModeActive"
      class="border-t-1 border-solid border-grey-divider-subdued pt-16"
    />
    <availability-calendar
      v-if="hasCalendarAvailability || editModeActive"
      :account-id="sitterId"
      :edit-mode-active="editModeActive"
      always-mobile-variant
      :class="hasCalendarAvailability ? 'border-t-1 border-solid border-grey-divider-subdued pt-16 mt-16' : ''"
    />
  </div>
</template>

<script lang="ts">
import GeneralAvailability from '@/components/general_availability/GeneralAvailability.vue';
import AvailabilityCalendar from '@/components/calendar/AvailabilityCalendar.vue';

export default {
  name: 'ProfileSchedule',
  components: {
    GeneralAvailability,
    AvailabilityCalendar,
  },
  props: {
    schedule: {
      type: Array,
      default: () => [],
    },
    sitterName: {
      type: String,
      default: 'the sitter',
    },
    sitterId: {
      type: String,
      default: '',
    },
    availabilityValidUntil: {
      type: String || null,
      default: null,
    },
    careType: {
      type: String,
      default: '',
    },
    editModeActive: {
      type: Boolean,
      default: false,
    },
    hasCalendarAvailability: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    showGeneralAvailability(): boolean {
      return this.schedule.length > 0 || this.editModeActive || !this.hasCalendarAvailability;
    },
  },
};
</script>
